var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.attr !== '')?_c('div',{staticClass:"badge badge-primary my-2"},[_vm._v(_vm._s(_vm.attr))]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }